import { render, staticRenderFns } from "./InputPercentageNovo.vue?vue&type=template&id=8665f29e&scoped=true"
import script from "./InputPercentageNovo.vue?vue&type=script&lang=js"
export * from "./InputPercentageNovo.vue?vue&type=script&lang=js"
import style0 from "./InputPercentageNovo.vue?vue&type=style&index=0&id=8665f29e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8665f29e",
  null
  
)

export default component.exports